import { useCssModule, computed, useSlots, ref, watch, onMounted } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useElevationProp } from "./assets/index-hC42R8vZ.js";
import { u as useFullWidthProp } from "./assets/index-4vIud5LZ.js";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import { u as useLinkProps } from "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XButton from "./XButton.js";
import XLink from "./XLink.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/index-D0Qy8ijJ.js";
import "./XSpinner.js";
const ALERT_TYPES = ["warning", "error", "success", "info"];
const { getFullWidthClass } = useFullWidthProp();
function useClasses(props) {
  const $style = useCssModule();
  const typeClass = computed(() => ({
    [$style[props.type]]: !!props.type
  }));
  const sizeClass = computed(() => ({
    [$style.isSmall]: props.small
  }));
  const elevationClass = computed(() => ({
    [$style.hasElevation]: props.elevation
  }));
  const { fullWidthClass } = getFullWidthClass(props);
  const alertClasses = computed(() => ({
    ...typeClass.value,
    ...sizeClass.value,
    ...elevationClass.value,
    ...fullWidthClass.value
  }));
  return { alertClasses };
}
const fadeInOutEnterActive = "_fadeInOutEnterActive_1y8g0_17";
const fadeIn = "_fadeIn_1y8g0_17";
const fadeInOutLeaveActive = "_fadeInOutLeaveActive_1y8g0_21";
const fadeOut = "_fadeOut_1y8g0_1";
const xAlert = "_xAlert_1y8g0_25";
const success = "_success_1y8g0_44";
const info = "_info_1y8g0_50";
const error = "_error_1y8g0_56";
const warning = "_warning_1y8g0_62";
const isSmall = "_isSmall_1y8g0_68";
const title = "_title_1y8g0_74";
const isFullWidth = "_isFullWidth_1y8g0_77";
const hasElevation = "_hasElevation_1y8g0_80";
const container = "_container_1y8g0_83";
const content = "_content_1y8g0_90";
const icon = "_icon_1y8g0_96";
const details = "_details_1y8g0_99";
const text = "_text_1y8g0_111";
const closeButton = "_closeButton_1y8g0_121";
const closeIcon = "_closeIcon_1y8g0_125";
const timeBar = "_timeBar_1y8g0_128";
const timeout = "_timeout_1y8g0_1";
const style0 = {
  fadeInOutEnterActive,
  fadeIn,
  fadeInOutLeaveActive,
  fadeOut,
  xAlert,
  success,
  info,
  error,
  warning,
  isSmall,
  title,
  isFullWidth,
  hasElevation,
  container,
  content,
  icon,
  details,
  text,
  closeButton,
  closeIcon,
  timeBar,
  timeout
};
const { createLinkProps, getLinkProps } = useLinkProps();
const { createIconProps } = useIconProps();
const { createFullWidthProp } = useFullWidthProp();
const { createElevationProp } = useElevationProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XAlert",
  components: { XIcon, XLink, XButton }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    type: {
      type: String,
      default: "",
      validator: (status) => ["", ...ALERT_TYPES].includes(status)
    },
    title: {
      type: String,
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: false
    },
    selfControl: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 3e3
    },
    autoClose: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    ...createLinkProps(),
    ...createElevationProp(Boolean, false),
    ...createFullWidthProp(),
    ...createIconProps(),
    ...createTestIdProp()
  },
  emits: ["close"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const { t } = useI18n();
    const { alertClasses } = useClasses(props);
    const { formatTestId } = setupTestId(props);
    const xAlertTimeBarEl = ref(null);
    const isVisibleInternal = ref(props.isVisible);
    const hasSlotDefault = computed(() => !!slots.default);
    function setTimeoutAnimation() {
      if (xAlertTimeBarEl.value) {
        xAlertTimeBarEl.value.style.animationDuration = `${props.timeout}ms`;
      }
    }
    function setIsVisibleInternal(newStatus) {
      isVisibleInternal.value = props.selfControl ? newStatus : props.isVisible;
    }
    function close() {
      emit("close", false);
      setIsVisibleInternal(false);
    }
    function setAutoClose() {
      if (props.autoClose) {
        setTimeout(() => {
          close();
        }, props.timeout);
      }
    }
    const linkProps = computed(() => ({
      small: props.small,
      ...getLinkProps(props)
    }));
    const iconProps = computed(() => ({
      icon: props.icon,
      size: props.small ? "lg" : "xl",
      "icon-style": props.iconStyle,
      "data-testid": formatTestId("icon")
    }));
    const timeBarProps = computed(() => ({
      "data-testid": formatTestId("timeBar")
    }));
    watch(
      () => props.isVisible,
      (newVisibility) => {
        setIsVisibleInternal(newVisibility);
        if (newVisibility) {
          setAutoClose();
        }
      },
      { immediate: true }
    );
    onMounted(() => {
      setTimeoutAnimation();
    });
    return { __sfc: true, createLinkProps, getLinkProps, createIconProps, createFullWidthProp, createElevationProp, createTestIdProp, setupTestId, props, emit, slots, t, alertClasses, formatTestId, xAlertTimeBarEl, isVisibleInternal, hasSlotDefault, setTimeoutAnimation, setIsVisibleInternal, close, setAutoClose, linkProps, iconProps, timeBarProps, XIcon, XButton, XLink };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("transition", { attrs: { "name": "fade", "enter-active-class": _vm.$style.fadeInOutEnterActive, "leave-active-class": _vm.$style.fadeInOutLeaveActive } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.isVisibleInternal, expression: "isVisibleInternal" }], class: [_vm.$style.xAlert, _setup.alertClasses], attrs: { "data-testid": _setup.formatTestId() } }, [_c("div", { class: _vm.$style.container }, [_c("div", { class: _vm.$style.content }, [_vm.icon ? _c(_setup.XIcon, _vm._b({ class: _vm.$style.icon }, "XIcon", _setup.iconProps, false)) : _vm._e(), _c("div", { class: _vm.$style.details, attrs: { "role": "alert", "aria-live": "polite" } }, [_vm.title ? _c("h5", { class: _vm.$style.title, attrs: { "data-testid": _setup.formatTestId("title") } }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _setup.hasSlotDefault ? _c("div", { class: _vm.$style.text, attrs: { "data-testid": _setup.formatTestId("text") } }, [_vm._t("default")], 2) : _vm._e(), _vm.linkText && _vm.to ? _c(_setup.XLink, _vm._b({ attrs: { "no-padding": "", "data-testid": _setup.formatTestId("link") } }, "XLink", _setup.linkProps, false), [_vm._v(" " + _vm._s(_vm.linkText) + " ")]) : _vm._e()], 1)], 1), _vm.closable ? _c(_setup.XButton, { class: _vm.$style.closeButton, attrs: { "model": "plain", "data-testid": _setup.formatTestId("closeButton"), "title": _setup.t("ds.xAlert.actions.close") }, on: { "click": function($event) {
    return _setup.close();
  } } }, [_c(_setup.XIcon, { class: _vm.$style.closeIcon, attrs: { "icon": "xmark-large", "size": _vm.small ? "sm" : "lg", "data-testid": _setup.formatTestId("closeButtonIcon") } })], 1) : _vm._e()], 1), _c("div", _vm._b({ directives: [{ name: "show", rawName: "v-show", value: _vm.autoClose, expression: "autoClose" }], ref: "xAlertTimeBarEl", class: _vm.$style.timeBar }, "div", _setup.timeBarProps, false))])]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XAlert = __component__.exports;
export {
  XAlert as default
};
